import React from "react"
import {
    Text
} from "@chakra-ui/react"

const FormError = ({error, ...props}) => {
    if(!error) return null
    return <Text fontSize='.8em' color='red.500' {...props}>{error}</Text>
}

export default FormError